<template>
  <div class="nowwa_content">
    <a-tabs @change="callback">
      <a-tab-pane v-for="item in option" :key="item.value" :tab="item.label" />
    </a-tabs>
    <el-table
      ref="tableData"
      v-loading="loading"
      :data="screenGoods"
      :show-summary="activeKey==='goods'"
      :summary-method="handleGetSummaries"
      :show-overflow-tooltip="true"
      header-border
      >
        <el-table-column
          label="序号"
          type="index"
          width="50">
        </el-table-column>
        <el-table-column 
          v-for="item in COLUMN" 
          :key="item.prop"
          :type="item.Type"
          :prop="item.prop"
          :label="item.label"
          :min-width="item.width"
          v-bind="item"
          >
           <template #default="scope">
              <template v-if="item.prop==='batchNo'">
                <el-tooltip
                  class="item"
                  effect="dark"
                  placement="top-start"
                >
                  <template #content>
                    批次号:{{ scope.row.batchNo }}
                    <p
                    v-for="(batchField) in scope.row.batchFields"
                    :key="batchField.fieldCode"
                    class="batch-field"
                    >
                      {{ batchField.fieldName }}:{{ batchField.paddingValue }}
                    </p>
                  </template>
                  <a-button type="link">{{ scope.row.batchNo }}</a-button>
               </el-tooltip>
              </template>
              <template v-else-if="item.prop==='action'" >
                <a-button
                  v-if="activeKey==='acceptanceDetails'"
                  type="link"
                  @click="handleSeeDiffInfo(scope.row)"
                >
                  查看差异情况
                </a-button>
              </template>
              <span v-else>{{item.formatter?item.formatter(scope.row):scope.row[item.prop]}}</span>
            </template>
        </el-table-column>
    </el-table>
    <differentDialog  ref="differentDialog"/>
  </div>
</template>

<script>
import {formatData} from '@/utils/util'
import {getDictionaryFromWms} from '@/pages/data/InventoryManage/api'
import {inboundOrderDetail} from '@/pages/warehouseOrder/api'
import tableSummary from '@/utils/tableSummary';
import {TABLECOLUMN} from '../tableColums'
import summaryConfig from './config'
import differentDialog from './differentDialog.vue'

const tabOption={
  goods:'货品明细',
  acceptanceDetails:'验收明细',
  upperShelfDetail:'上架详情',
}
  export default {
    name:'NowwaWareDetailTable',
    components:{differentDialog},
    props:{
      receiptOrderNo:{
        type:String,
        default:'',
        loading:false
      }
    },
    data(){
      return{
        activeKey:'goods',
        GOODS_QUALITY:[],
        detail:{}
      }
    },
    computed:{
      option(){
        return formatData(tabOption)
      },
      COLUMN(){
         return TABLECOLUMN(this.activeKey,this.GOODS_QUALITY)
      },
      screenGoods(){
        return this.detail[this.activeKey]
      }
    },
    created(){
      this.getDictionaryFrom()
      this.getDetail()
    },
    methods:{
      handleGetSummaries({ columns, data }) {
        const config = summaryConfig.get(1);
        const sums = [];
        columns.forEach((column, index) => {
          if (index === 0) {
            sums[index] = '合计';
            return;
          }
          sums[index] = tableSummary({ column, data, config });
        });
        return sums;
      },
      async getDetail(){
        this.loading = true;
        const result = await inboundOrderDetail({
          receiptOrderNo: this.receiptOrderNo,
          needAcceptance: true,
          needUpperShelf: true,
          needStore: true,
        });
        this.detail = result;
        this.loading = false;
      },
      async getDictionaryFrom(){
        const res=await getDictionaryFromWms()
        this.GOODS_QUALITY= this.setDictionaryFormat(res,"GOODS_QUALITY")
      },
      setDictionaryFormat(data,code){
        const list = data.find(item=>item.dictionaryCode===code).dictionaryValues
        return list.map((item) => ({
          value: item.code,
          label: item.name,
        }))
      },
      callback(value){
        this.activeKey=value;
      },
      async handleSeeDiffInfo(rowData) {
        await this.$nextTick();
        // 不等于验收中 展示缺货量
        const showLockNum = this.detail.receiptStatus !== 'ACCEPTING';
        this.$refs.differentDialog.showDialog(rowData, true, showLockNum);
      },
    }
  }
</script>

<style lang="less" scoped>
.nowwa_content{
  padding: 24px 0;
}
</style>